// @flow

import * as React from "react"
import {hot} from "react-hot-loader"
import {connect} from "react-redux"
import {ToastContainer, Slide} from "react-toastify"
import {Router, Route, Switch, Redirect} from "react-router-dom"

import {fetchUser} from "./actions/user"
import {Spinner} from "./loadable"

import type {State, User, Dispatch} from "./types"

type AppProps = {
  store: any,
  user: User,
  dispatch: Dispatch,
}

type AppState = {
  isLoading: boolean,
}

import IntakeDataGeneralView from "./views/intake/data/general"
import IntakeDataSurveyView from "./views/intake/data/survey"
import IntakeDataInfoView from "./views/intake/data/info"
import IntakeBabyListView from "./views/intake/baby-list"
import IntakeProductsView from "./views/intake/products"
import IntakeViewWrapper from "./views/intake/wrapper"
import SearchItemsDashboardView from "./views/dashboard/search-items"
import BabiesDashboardView from "./views/dashboard/babies"
import PlanningDashboardView from "./views/dashboard/planning"
import PlanningViewDashboardView from "./views/dashboard/planning-view"
import ShopAdminView from "./views/shop/admin"
import BabyListInvoiceView from "./views/baby-list-invoice"
import InvoiceView from "./views/invoice"

class App extends React.Component<AppProps, AppState> {
  state = {isLoading: true}

  componentDidMount() {
    const {dispatch} = this.props
    Promise.all([dispatch(fetchUser())]).then(() => {
      this.setState({isLoading: false})
    })
  }

  render() {
    if (this.state.isLoading) return <Spinner />
    if (!this.props.user) return null
    return (
      <Router history={window.menageHistory}>
        <React.Fragment>
          <Route
            path="/intake/:babyToken"
            render={({match: {path}}) => (
              <IntakeViewWrapper>
                <Switch>
                  <Route
                    path={`${path}/data/*`}
                    render={() => (
                      <Switch>
                        <Route
                          path={`${path}/data/general`}
                          component={IntakeDataGeneralView}
                        />
                        <Route
                          path={`${path}/data/info`}
                          component={IntakeDataInfoView}
                        />
                        <Route
                          path={`${path}/data/survey`}
                          component={IntakeDataSurveyView}
                        />
                        <Route
                          path={`${path}`}
                          component={IntakeDataGeneralView}
                        />
                      </Switch>
                    )}
                  />
                  <Route
                    path={`${path}/categories/:categoryId/:pid?`}
                    component={IntakeProductsView}
                  />
                  <Route path={`${path}/list`} component={IntakeBabyListView} />
                  <Redirect from={path} to={`${path}/list`} />
                </Switch>
              </IntakeViewWrapper>
            )}
          />

          <Route
            path="/admin/dashboard"
            render={({match: {path}}) => (
              <Switch>
                <Route
                  path={`${path}/search-items`}
                  component={() => (
                    <SearchItemsDashboardView isStandalone={false} />
                  )}
                />
                <Route
                  path={`${path}/babies`}
                  component={BabiesDashboardView}
                />
                <Route
                  path={`${path}/planning`}
                  component={PlanningDashboardView}
                />
                <Route
                  path={`${path}/intake-agenda`}
                  component={PlanningViewDashboardView}
                />
                <Route
                  path={`${path}`}
                  component={() => (
                    <SearchItemsDashboardView isStandalone={false} />
                  )}
                />
              </Switch>
            )}
          />

          <Route path="/admin/invoicing/:id" component={InvoiceView} />

          <Route
            path="/admin/babies/:id"
            render={({match: {path}}) => (
              <Switch>
                <Route
                  path={`${path}/products`}
                  component={() => (
                    <SearchItemsDashboardView isStandalone={true} />
                  )}
                />
                <Route
                  path={`${path}/planning`}
                  component={PlanningDashboardView}
                />
                <Route path={`${path}/shop`} component={ShopAdminView} />
                <Route
                  path={`${path}/invoicing/:invoiceId`}
                  component={BabyListInvoiceView}
                />
              </Switch>
            )}
          />

          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={true}
            pauseOnHover={false}
            className=""
            transition={Slide}
          />
        </React.Fragment>
      </Router>
    )
  }
}

const mapStateToProps = (state: State) => ({user: state.user.entity})

const AppHOC = connect(mapStateToProps)(App)
const HotAppHOC = hot(module)(AppHOC)

export default HotAppHOC
